/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import MEIMarketPage from 'src/pages/ReportsPages/ReportsBoard/MEIpages/MEIMarketPage'
import boardReportsService from 'src/services/boardReportsService'

const MEIMarketTotalsContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [table1, setTable1] = useState([])
  const [gMei1, setGMei1] = useState([])
  const [meiMarketRegions, setMeiMarketRegions] = useState([])
  const [gAMeiMarketRegions, setGAMEIMarketRegions] = useState([])
  const [gBMeiMarketRegions, setGBMEIMarketRegions] = useState([])

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  const reloadImports = async () => {
    const [
      table1,
      gMei1,
      meiMarketRegions,
      gAMeiMarketRegions,
      gBMeiMarketRegions,
    ] = await Promise.all([
      boardReportsService.getTotalMEI(1, selectedDate.getFullYear()),
      boardReportsService.graphicsTotalMEI(1, selectedDate.getFullYear()),
      boardReportsService.getTotalMEI(2, selectedDate.getFullYear()),
      boardReportsService.graphicsTotalMEI('2a', selectedDate.getFullYear()),
      boardReportsService.graphicsTotalMEI('2b', selectedDate.getFullYear()),
    ])
    setTable1(table1)
    setGMei1(gMei1)
    setMeiMarketRegions(meiMarketRegions)
    setGAMEIMarketRegions(gAMeiMarketRegions)
    setGBMEIMarketRegions(gBMeiMarketRegions)
  }

  useEffect(() => {
    reloadImports()
  }, [])

  return (
    <MEIMarketPage
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
      meiMarketRegions={meiMarketRegions}
      gAMeiMarketRegions={gAMeiMarketRegions}
      gBMeiMarketRegions={gBMeiMarketRegions}
      table1={table1}
      gMei1={gMei1}
    />
  )
}

export default MEIMarketTotalsContainer
